import * as React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Image from "../public/IntelligentVIEW_Splash.svg";
import { REACT_APP_IV_URL } from "../helpers/constants";

export default function Splash() {
  return (
    <Grid
      item
      md={6}
      sx={{
        display: { sm: "none", md: "flex" },
        backgroundColor: "background.splash",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Stack
        sx={{
          flex: 1,
          backgroundImage: `url(${Image})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "290px 290px",
          width: "100%",
        }}
      />
      <Stack
        sx={{
          flex: 1,
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          fontSize: "0.9rem",
          textAlign: "left",
          width: "400px",
        }}
      >
        <h3 style={{ margin: 0 }}>intelligentVIEW by CiG</h3>
        <Typography
          style={{ maxWidth: 600, textAlign: "left", margin: "4px 0" }}
        >
          Canada’s leading audience insights & media activation platform, built
          for precision targeting and privacy compliance.
        </Typography>
        <ul style={{ paddingLeft: 20, margin: "4px 0" }}>
          <li>
            <strong>Rich insights engine</strong>: 30,000+ attributes across
            ~780,000 postal codes.
          </li>
          <li>
            <strong>Instant analytics</strong>: Dynamic reports, cohorts, maps,
            and intelligentSEGMENTS.
          </li>
          <li>
            <strong>Seamless activation</strong>: Push to Meta, TikTok, DV360,
            and direct mail.
          </li>
        </ul>
        <p style={{ marginTop: 8 }}>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://kb.intelligentview.ca/"
          >
            Knowledge Base
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://consumerig.com/faqs/"
          >
            FAQs
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href={`${REACT_APP_IV_URL}/scontent/privacy_policy.html`}
          >
            Privacy Policy
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href={`${REACT_APP_IV_URL}/scontent/terms_of_use.html`}
          >
            Terms of Use
          </a>
        </p>
      </Stack>
    </Grid>
  );
}
